module.exports = __webpack_public_path__ + "img/shili_03@3x.106777e9.png";